import styled from 'styled-components'
const CustomTable = styled.div`
  position: relative;
  width: 100%;
  min-width: max-content;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-sizing: border-box;
  overflow: auto;
`

const Thead = styled.div`
  height: 3rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7fafc;
  border-radius: 8px 8px 0 0;
`

const Tbody = styled.div`
  width: 100%;
`

const ThDiv = styled.div`
  display: flex;
  ${props => props.width && `flex: 0 0 ${props.width};`}
  justify-content: space-between;
  align-items: center;
  border: none;
  background-color: transparent;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: #5e5873;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    opacity: 0;
  }

  &:hover {
    svg {
      opacity: 1;
    }
  }

  &[data-centered='true'] {
    justify-content: center;
    gap: 0.5rem;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
  }
`

const ThButton = styled.button`
  display: flex;
  ${props => props.width && `flex: 0 0 ${props.width};`}
  justify-content: space-between;
  align-items: center;
  border: none;
  background-color: transparent;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: #5e5873;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    opacity: 0;
  }

  &:hover {
    svg {
      opacity: 1;
    }
  }

  &[data-centered='true'] {
    justify-content: center;
    gap: 0.5rem;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
  }
`

const Tr = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;

  &:hover {
    background-color: #f7fafc;
  }
`

const Td = styled.div`
  display: flex;
  ${props => props.width && `flex: 0 0 ${props.width};`}
  padding: 0.5rem 1rem;
  overflow: hidden;
  text-overflow: ellipsis;

  &[data-centered='true'] {
    justify-content: center;
    align-items: center;
  }
`

const LocationStatus = styled.span`
  display: flex;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 0.375rem 1.2rem;
  border-radius: 4px;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.25rem;

  &[data-status='OPEN'] {
    color: #24b364;
    background-color: #28c76f14;
    border: 1px solid #7edda9;
  }

  &[data-status='CLOSED_PERMANENTLY'] {
    color: #e64449;
    background-color: #ff4c5114;
    border: 1px solid #ff9497;
  }

  &[data-status='CLOSED_TEMPORARILY'] {
    color: #e68f3c;
    background-color: #ff9f4314;
    border: 1px solid #ffc58e;
  }
`

const LocationCode = styled.span`
  color: #161616;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1rem;
`

const LocationAddress = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;

  > div:nth-child(1) {
    color: #161616;
    font-size: 0.9rem;
    font-weight: 600;
  }

  > div:nth-child(2) {
    color: #74788d;
    font-size: 0.875rem;
    font-weight: 400;
  }
`

const LocationProfile = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;

  a {
    padding: 0.3rem;
    aspect-ratio: 1/1;
  }

  a:hover {
    border-radius: 99999px;
    background-color: #f9f9f9;
  }

  a[id^='google-link-'] {
    margin-top: -2px;
  }

  button {
    background-color: transparent;
    border: none;
    padding: 0;

    &:focus-visible {
      outline: none;
    }

    &:focus {
      outline: none;
    }
  }
`

const ScoreProgressBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  background: radial-gradient(closest-side, white 79%, transparent 80% 100%),
    conic-gradient(
      ${props => props?.color} ${props => props?.content}%,
      #e2e8f0 0
    );

  &::before {
    content: '${props => props?.content}%';
    color: #718096;
    font-size: 0.8rem;
    font-weight: 500;
  }

  meter {
    visibility: hidden;
    height: 0;
    width: 0;
  }

  &:hover {
    &::before {
      font-size: 0.9rem;
    }
  }
`

const FullScoreProgressBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  border: 3px solid #48bb78;
`

const LocationEdit = styled.a`
  text-align: center;
`

const Styles = {
  CustomTable,
  Thead,
  Tbody,
  ThDiv,
  ThButton,
  Tr,
  Td,
  LocationStatus,
  LocationCode,
  LocationAddress,
  LocationProfile,
  ScoreProgressBar,
  FullScoreProgressBar,
  LocationEdit,
}

export default Styles
